import { useContext } from "react"
import { InformationCircleIcon } from "@heroicons/react/24/outline"
import { ModalKey, ModalContext } from 'components/Modals/ModalContext'
import { getExerciseInfo } from 'functions/assessmentSummaryUtils'

const BAR_PARENT_HEIGHT = 8
const BAR_HEIGHT = 6

export default function AssessmentSummaryExerciseSetListItem({
    selectedSide,
    exerciseId,
    exerciseName,
    exerciseLateral,
    currentSet,
    percentageScore
}) {

    const { ShowModal } = useContext(ModalContext)

    const ShowInfoModal = () => {

        const exerciseInfo = getExerciseInfo(exerciseId)

        const modalData = {
            key: ModalKey.ExerciseAssessmentInfo,
            fullscreen: true,
            exerciseName: exerciseName,
            exerciseLateral: exerciseLateral,
            currentSet: currentSet,
            exerciseInfo: exerciseInfo
        }

        ShowModal(modalData)
    }

    return (
        <div>

            {/* Debug Component */}
            {/* 
            <div>{exerciseLateral}</div>

            <pre className="text-xs p-2 bg-gray-100 border-gray-400 overflow-x-auto">
                {JSON.stringify(currentSet, null, 2)}
            </pre> 
            */}

            <div 
                className="w-full text-center text-gray-600 text-xs font-bold cursor-pointer"
                onClick={() => ShowInfoModal()}
            >
                <span className="flex items-center justify-center">
                    {exerciseName}
                    <InformationCircleIcon 
                        className="ml-1 w-4 h-4 text-gray-600" 
                    />
                </span>
            </div> 
        
            <div className={`relative h-${BAR_PARENT_HEIGHT}`}>

                <div className={`absolute w-full h-${BAR_HEIGHT} top-1/2 -translate-y-1/2 bg-gray-300 rounded-lg`} />

                <div className="absolute left-1/2 h-full w-[2px] bg-white z-10" />

                {exerciseLateral === 'unilateral' && 
                    <>

                        <div 
                            className={`
                                absolute top-1/2 right-[50%] h-${BAR_HEIGHT} -translate-y-1/2 rounded-l-lg
                                ${selectedSide === 'left' ? 'bg-orange-400' : 'bg-orange-300'}
                            `}
                            style={{
                                width: `${currentSet.completedSetData.setUnitsCompleted.leftSidePercentageScore / 2}%`
                            }}
                        />
                        
                        <div 
                            className={`
                                absolute top-1/2 left-[50%] h-${BAR_HEIGHT} -translate-y-1/2 rounded-r-lg
                                ${selectedSide === 'right' ? 'bg-orange-400' : 'bg-orange-300'}
                            `}
                            style={{
                                width: `${currentSet.completedSetData.setUnitsCompleted.rightSidePercentageScore / 2}%`
                            }}
                        />

                        <div
                            className="absolute top-1/2 left-[35%] -translate-x-1/2 -translate-y-1/2 text-white text-xs font-bold z-10 text-right w-[20%]"
                            style={{ textShadow: '0.5px 0.5px 0 #111, -0.5px -0.5px 0 #111, 0.5px -0.5px 0 #111, -0.5px 0.5px 0 #111, 0.5px 0.5px 0 #111' }}
                        >
                            {Math.round((currentSet.completedSetData.setUnitsCompleted.leftSidePercentageScore))}%
                        </div>

                        <div
                            className="absolute top-1/2 left-[65%] -translate-x-1/2 -translate-y-1/2 text-white text-xs font-bold z-10 text-left w-[20%]"
                            style={{ textShadow: '0.5px 0.5px 0 #111, -0.5px -0.5px 0 #111, 0.5px -0.5px 0 #111, -0.5px 0.5px 0 #111, 0.5px 0.5px 0 #111' }}
                        >
                            {Math.round((currentSet.completedSetData.setUnitsCompleted.rightSidePercentageScore))}%
                        </div>
                        
                    </>
                }

                {exerciseLateral === 'bilateral' && 
                    <>

                        <div 
                            className={`
                                absolute top-1/2 right-[50%] h-${BAR_HEIGHT} -translate-y-1/2 rounded-l-lg
                                ${selectedSide === 'left' ? 'bg-orange-400' : 'bg-orange-300'}
                            `}
                            style={{
                                width: `${Math.round(percentageScore / 2)}%`                                
                            }}
                        />
                        
                        <div 
                            className={`
                                absolute top-1/2 left-[50%] h-${BAR_HEIGHT} -translate-y-1/2 rounded-r-lg
                                ${selectedSide === 'right' ? 'bg-orange-400' : 'bg-orange-300'}

                            `}
                            style={{
                                width: `${Math.round(percentageScore/2)}%`
                            }}
                        />

                        <div
                            className="absolute top-1/2 left-[35%] -translate-x-1/2 -translate-y-1/2 text-white text-xs font-bold z-10 text-right w-[20%]"
                            style={{ textShadow: '0.5px 0.5px 0 #111, -0.5px -0.5px 0 #111, 0.5px -0.5px 0 #111, -0.5px 0.5px 0 #111, 0.5px 0.5px 0 #111' }}
                        >
                            {Math.round(percentageScore)}%
                        </div>

                        <div
                            className="absolute top-1/2 left-[65%] -translate-x-1/2 -translate-y-1/2 text-white text-xs font-bold z-10 text-left w-[20%]"
                            style={{ textShadow: '0.5px 0.5px 0 #111, -0.5px -0.5px 0 #111, 0.5px -0.5px 0 #111, -0.5px 0.5px 0 #111, 0.5px 0.5px 0 #111' }}
                        >
                            {Math.round(percentageScore)}%
                        </div>

                    </>
                }

            </div>

        </div>
    )

}